import {
  COUNTRIES_WITH_ALLOWLISTED_BORDERS,
  COUNTRIES_WITH_ALLOWLISTED_BORDERS_PLUS_USA
} from '../../domain/country'

/**
 * Refines search filters based on geographic location. This function adjusts search filters to ensure
 * search results are regionally relevant, with special handling for allowlisted countries such as the USA and Canada.
 * If the user's location is in a allowlisted country, the search is tailored to include results from that country.
 * For locations outside the allowlisted countries, the search is filtered to exclude the allowlisted countries.
 *
 * @param {Object} searchState - The current state of the search, including user's location and other search parameters.
 * @returns {Array<string>} An array of filter strings tailored to the user's geographic location.
 *
 */
export const getGeoLocationFiltersFromSearchState = (searchState) => {
  let filters = []
  const locationDescription = searchState?.locationName

  // locationDescription is a string like "California, USA"
  const terms = locationDescription?.split(', ') || []
  const location = terms[0]
  const locationAddressParts = terms.length === 1 ? terms : terms.slice(1)
  // to cover cases where the country appear as USA instead of United States
  const countriesAllowListed = new Set(
    COUNTRIES_WITH_ALLOWLISTED_BORDERS_PLUS_USA
  )

  const locationIsAllowListedCountry =
    COUNTRIES_WITH_ALLOWLISTED_BORDERS.has(location)
  let allowlistedCountry = locationIsAllowListedCountry
    ? location
    : locationAddressParts
        ?.map((title) => title)
        .find((title) => countriesAllowListed.has(title))

  if (!locationIsAllowListedCountry && !searchState?.configure?.aroundLatLng) {
    filters.push(`locations: "${location}"`)
  }

  if (allowlistedCountry) {
    allowlistedCountry =
      allowlistedCountry === 'USA' ? 'United States' : allowlistedCountry
    filters.push(`locations: "${allowlistedCountry}"`)
  }

  if (!allowlistedCountry) {
    COUNTRIES_WITH_ALLOWLISTED_BORDERS.forEach((country) => {
      filters.push(`NOT locations: "${country}"`)
    })
  }

  return filters
}
